import React from 'react';
import RoomComponent from "./RoomComponent";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

const RoomBreakdownComponent = ({roomBreakdown, onNoOfRoomsChange}) => {
  let options = [];
  for (let i = 1; i < 5; i++) {
     options.push(<MenuItem value={i} primaryText={i} />)
  }

  let inventory = [];
  let index = 0;
  for(let room of roomBreakdown) {
    inventory.push(<RoomComponent index={index++} inventoryType={room} />);
  }

  const styles = {
    customWidth: {
      width: 80,
    },
  };

  return(
   <div>
     <div className="searchBarItem">
      <SelectField style={styles.customWidth} floatingLabelText="Rooms" value={roomBreakdown.length} onChange={(e, key, value) => onNoOfRoomsChange(value)}>
       {options}
      </SelectField>
     </div>
     <div className="searchBarRoomBreakdown">
      {inventory}
     </div>
   </div>
  )
};

export default RoomBreakdownComponent;


// WEBPACK FOOTER //
// ./src/components/RoomBreakdownComponent.js